/**
 * 用户意见管理
 */
export default {
  // insertUserFeedbackReply: "/userFeedback/insertUserFeedbackReply", //   回复意见
  // selectUserFeedbackDetail: "/userFeedback/selectUserFeedbackDetail", //   意见详情
  // selectUserFeedbackList: "/userFeedback/selectUserFeedbackList", //   意见列表

  userFeedbackreply: '/userFeedback/reply', // 回复
  userFeedbackselectUserFeedback: '/userFeedback/selectUserFeedback', // 查询用户意见（后台）
  userFeedbackselectUserFeedbackDetail: '/userFeedback/selectUserFeedbackDetail', // 查询用户意见详情
}